/** Default conditions copy for UK Status Match campaigns. */
export const DEFAULT_STATUS_MATCH_CONDITION_DEFINITIONS = [
  {
    icon: 'clock',
    title: 'Once per member',
    description: 'Available once per member, every 3 years. Only one submission at a time.',
  },
  {
    icon: 'calendar',
    title: 'Three months to complete',
    description: 'Book a Hotel, Tour or Cruise and travel within 3 months of pre-approval, min. 3 nights.',
  },
  {
    icon: 'star',
    title: 'Earn Silver or Gold status',
    description:
      'Your matched status tier is earned until your tier review date, which is at the end of your following membership year.',
  },
  {
    icon: 'lock',
    title: 'Tailored for our UK customers',
    description: 'Available to select Société members in the UK. Gold and Platinum members are not eligible.',
  },
] as const;
